import { render, staticRenderFns } from "./EditGroupTopicList.vue?vue&type=template&id=13302652"
import script from "./EditGroupTopicList.vue?vue&type=script&lang=js"
export * from "./EditGroupTopicList.vue?vue&type=script&lang=js"
import style0 from "./EditGroupTopicList.vue?vue&type=style&index=0&id=13302652&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports